/**
 * Cookiebot (and occasionally Google Maps) throw SecurityError when their
 * iframe touches window.parent / window.top across origin. That is the
 * browser doing its job, not an application bug (RR-362).
 */
const CROSS_ORIGIN_FRAME = [
  /Blocked a frame with origin/i,
  /from accessing a cross-origin (?:frame|object)/i,
  /Permission denied to access property .+ on cross-origin/i,
  /Failed to read a named property .+ from 'Window'/i
];

export const isCrossOriginFrameError = value => {
  if (value == null) return false;

  const message = typeof value === "string" ? value : String(value.message || "");

  return CROSS_ORIGIN_FRAME.some(pattern => pattern.test(message));
};
